var _style, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExperience(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B92D22;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.8,166.7c-4.9,0-9.2-4.1-9.7-9.2L0,156.3v-146C0,5.1,3.9,0.6,8.8,0.1L9.9,0h62.6c1.8,0,3.6,0.5,5.2,1.6 l1.1,0.8l23.5,14.8h88c4.9,0,9.2,4.1,9.7,9.2l0.1,1.1V58c0,3.3-2.5,6-5.5,6c-2.7,0-5.1-2.2-5.4-5.2l-0.1-0.9V29.2h-87.2 c-1.8,0-3.6-0.5-5.2-1.6l-1.1-0.8L72.1,12H11v142.6h97.6c2.7,0,5.1,2.2,5.4,5.2l0.1,0.9c0,3-2.1,5.5-4.8,5.9l-0.8,0H9.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.5,200c-4.4,0-6.3-1.9-6.3-6.3s1.9-6.3,6.3-6.3h58.3c4.4,0,6.3,1.9,6.3,6.3s-1.9,6.3-6.3,6.3H135.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.5,166.7c-4.4,0-6.3-1.9-6.3-6.3s1.9-6.3,6.3-6.3h58.3c4.4,0,6.3,1.9,6.3,6.3s-1.9,6.3-6.3,6.3H135.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.5,133.3c-4.4,0-6.3-1.9-6.3-6.3s1.9-6.3,6.3-6.3h58.3c4.4,0,6.3,1.9,6.3,6.3s-1.9,6.3-6.3,6.3H135.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.7,64.7c-4.4,0-6.3-1.9-6.3-6.3c0-4.4,1.9-6.3,6.3-6.3h116.7c4.4,0,6.3,1.9,6.3,6.3c0,4.4-1.9,6.3-6.3,6.3 H41.7z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperience);
export default __webpack_public_path__ + "static/media/experience.1881e0d3805c70b820632697a6568db0.svg";
export { ForwardRef as ReactComponent };